import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { userFormConfig } from '../../config/user-form.config';
import { User } from '../../../core/models/user.model';
import { UserService } from '../../../../services/user/user.service';
import {
  EoFormComponent,
  STATUS,
} from 'ngx-eo-web-components';
import { Subscription, filter } from 'rxjs';
import { CoreService } from '../../../core/core.service';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-user-form-dialog',
  templateUrl: './user-form-dialog.component.html',
  styleUrls: ['./user-form-dialog.component.scss'],
})
export class UserFormDialogComponent {
  subscriptions: Subscription[] = [];
  @ViewChild('eoForm', { static: false }) eoForm?: EoFormComponent;

  user?: User;
  visible = false;
  formConfig = [...userFormConfig];

  @Output() success = new EventEmitter();

  constructor(
    private userService: UserService,
    private coreService: CoreService
  ) {}

  ngOnInit(): void {
    this.subscriptions = [
      this.getUserSaveSuccessSub$(),
      this.getUserUpdateSuccessSub$(),
    ];
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  onSubmit($event: any) {
    if (!$event?.user) return;

    let userToStore = {
      ...this.user,
      userName: $event.user.userName,
      email: $event.user.email,
      name: $event.user.name,
      surname: $event.user.surname,
      lockoutEnabled: $event.user.lockoutEnabled || false,
      roles: [$event.user.role],
      hospitalID: $event.user.hospital,
    };

    userToStore.userID
      ? this.userService.updateUser(userToStore as User).subscribe()
      : this.userService.saveUser(userToStore).subscribe();
  }

  onSubmitSuccess(): void {
    this.userService.init();
    this.visible = false;
    this.showSuccessMessage();
    this.success.emit();
  }

  initForm() {
    this.eoForm?.form.reset();
    this.eoForm?.form.enable();

    if (this.user) {
      this.setFcValue('userName', this.user.userName);
      this.setFcValue('email', this.user.email);
      this.setFcValue('name', this.user.name);
      this.setFcValue('surname', this.user.surname);
      this.setFcValue('lockoutEnabled', this.user.lockoutEnabled);
      this.setFcValue('hospital', this.user.hospitalID);
      this.setFcValue('role', this.user.roles?.[0]);

      this.eoForm?.getFormControl('user', 'userName')?.disable();
    }

    this.updateHospitalValidator();
  }

  showSuccessMessage(): void {
    this.coreService.showSuccess('Ο χρήστης αποθηκεύτηκε με επιτυχία');
  }

  setFcValue(formControlName: string, value: any) {
    return this.eoForm?.setValue('user', formControlName, value);
  }

  getHeader(): string {
    return this.user?.userID ? 'Επεξεργασία Χρήστη' : 'Νέος Χρήστης';
  }

  getFormConfig() {
    return this.formConfig;
  }

  getUserSaveSuccessSub$() {
    return this.userService.userSaveCallHandler.status$
      .pipe(filter((s) => s === STATUS.success))
      .subscribe(() => {
        this.onSubmitSuccess();
      });
  }

  getUserUpdateSuccessSub$() {
    return this.userService.userUpdateCallHandler.status$
      .pipe(filter((s) => s === STATUS.success))
      .subscribe(() => {
        this.onSubmitSuccess();
      });
  }

  isSubmitLoading(): boolean {
    let uSaveStatus = this.userService.userSaveCallHandler?.status$?.getValue();
    if (uSaveStatus === STATUS.loading) return true;

    let uUpdStatus = this.userService.userUpdateCallHandler?.status$?.getValue();
    if (uUpdStatus === STATUS.loading) return true;

    return false;
  }

  isHospitalDropdownVisible(): boolean {
    return this.isHospitalRoleSelected();
  }

  private isHospitalRoleSelected() {
    const role = this.eoForm?.getFormControl('user', 'role')?.value;
    return role === 'HospitalAdmin' || role === 'ClinicAdmin';
  }

  private updateHospitalValidator() {
    const roleControl = this.eoForm?.getFormControl('user', 'role');
    const hospitalControl = this.eoForm?.getFormControl('user', 'hospital');

    if (roleControl && hospitalControl) {
      roleControl.valueChanges.subscribe((role) => {
        if (role === 'HospitalAdmin' || role === 'ClinicAdmin') {
          hospitalControl.setValidators([Validators.required]);
        } else {
          hospitalControl.clearValidators();
        }
        hospitalControl.updateValueAndValidity();
      });
    }
  }

  show(user?: User): void {
    this.user = user;
    this.initForm();
    this.visible = true;
  }
}